/* Hang Dry: cookie banner as a slim bottom bar.
   One line of copy with Privacy and Manage links, then Decline and Accept.
   Shopify's own buttons and links are moved, not copied, so they keep doing the work
   through the Customer Privacy API. Manage opens Shopify's settings panel, where the
   Preferences category is hidden because the site does not use it. */
(function () {
  if (window.__hdConsent) return;
  window.__hdConsent = true;

  function label(el, text) {
    if (!el) return;
    var s = el.querySelector('span');
    (s || el).textContent = text;
  }

  function build(banner) {
    if (banner.getAttribute('data-hd-bar')) return true;
    var btns = banner.querySelector('.shopify-pc__banner__btns');
    var acc = banner.querySelector('#shopify-pc__banner__btn-accept');
    var dec = banner.querySelector('#shopify-pc__banner__btn-decline');
    var man = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    var body = banner.querySelector('.shopify-pc__banner__body');
    if (!btns || !acc || !dec || !body) return false;
    banner.setAttribute('data-hd-bar', '');

    var link = banner.querySelector('#shopify-pc__banner__body-policy-link');
    var p = document.createElement('p');
    p.className = 'hd-consent__copy';
    p.appendChild(document.createTextNode('We use cookies for analytics and ads. Your call. '));
    if (link) { link.textContent = 'Privacy'; p.appendChild(link); }
    if (man) {
      label(man, 'Manage');
      if (link) { var dot = document.createElement('span'); dot.className = 'hd-consent__dot'; dot.textContent = '·'; dot.setAttribute('aria-hidden', 'true'); p.appendChild(dot); }
      p.appendChild(man);
    }
    body.innerHTML = '';
    body.appendChild(p);

    label(dec, 'Decline');
    label(acc, 'Accept');
    btns.insertBefore(dec, btns.firstChild);
    btns.insertBefore(acc, dec.nextSibling);
    return true;
  }

  // Shopify's settings panel: hide the Preferences row (unused on this site)
  function trimPrefs() {
    var prefs = document.getElementById('shopify-pc__prefs');
    if (!prefs) return;
    prefs.querySelectorAll('input[type="checkbox"]').forEach(function (i) {
      var key = ((i.id || '') + ' ' + (i.name || '') + ' ' + (i.value || '')).toLowerCase();
      if (key.indexOf('preferences') === -1) return;
      var row = i.closest('.shopify-pc__prefs__option') || i.closest('li') || i.parentNode;
      if (row) row.style.display = 'none';
    });
  }

  function scan() {
    var b = document.getElementById('shopify-pc__banner');
    if (b) build(b);
    trimPrefs();
  }

  scan();
  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 30); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 600000);
})();
